module.exports = __webpack_public_path__ + "img/icon_ok.53b7833c.png";